import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axiosInstance from "../../Shared/axiosInstance";
import CustomDatePicker from "../CustomDate/CustomDatePicker";


export default function أعلى_الأرباح() {
  const API = "/Sale/top-profit";

  const [profits, setProfits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [topCount, setTopCount] = useState(5);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // حساب المجاميع
  const totalProfit = profits.reduce((sum, item) => sum + item.totalProfit, 0);
  const totalRevenue = profits.reduce((sum, item) => sum + item.totalRevenue, 0);
  const totalCost = profits.reduce((sum, item) => sum + item.totalCost, 0);
  const totalQuantity = profits.reduce((sum, item) => sum + item.totalQuantitySold, 0);
  const avgProfitMargin = profits.length > 0 ? profits.reduce((sum, item) => sum + item.profitMargin, 0) / profits.length : 0;
  const avgMarkup = profits.length > 0 ? profits.reduce((sum, item) => sum + item.markup, 0) / profits.length : 0;

  // جلب البيانات
  const fetchTopProfits = async () => {
    setLoading(true);
    try {
      const params = { topCount };
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      const { data } = await axiosInstance.get(API, { params });
      setProfits(data?.data || []);
    } catch (err) {
      console.error("خطأ أثناء جلب أعلى الأرباح:", err);
      Swal.fire("خطأ", "فشل تحميل بيانات الأرباح", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopProfits();
  }, []);

  // تطبيق الفلاتر
  const handleFilter = () => {
    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      Swal.fire("تحذير", "تاريخ البداية لا يمكن أن يكون بعد تاريخ النهاية", "warning");
      return;
    }
    fetchTopProfits();
  };

  // إعادة الضبط
  const handleReset = () => {
    setTopCount(5);
    setFromDate("");
    setToDate("");
    setTimeout(() => fetchTopProfits(), 100);
  };

  // Loading قبل return
  if (loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #dbeafe",
            borderTop: "4px solid #2563eb",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p style={{ marginTop: "20px", color: "#64748b", fontSize: "18px" }}>
          جارٍ تحميل المنتجات الأعلى ربحاً...
        </p>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "1800px", margin: "0 auto", padding: "40px 20px", direction: "rtl" }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px" }}>
        <div>
          <h2 style={{ color: "#2563eb", fontWeight: "700", fontSize: "28px", marginBottom: "4px" }}>
            أعلى المنتجات ربحاً
          </h2>
          <small style={{ color: "#64748b", fontSize: "14px" }}>
            عرض أعلى {profits.length} منتجات من حيث الربح
          </small>
        </div>
      </div>

      {/* Filters Section */}
      <div style={filterBoxStyle}>
        <h5 style={filterTitleStyle}>خيارات التصفية</h5>
        <div style={filterGridStyle}>
          <div>
            <label style={filterLabelStyle}>عدد الأعلى</label>
            <select value={topCount} onChange={(e) => setTopCount(Number(e.target.value))} style={selectStyle}>
              <option value={5}>Top 5</option>
              <option value={10}>Top 10</option>
              <option value={15}>Top 15</option>
              <option value={20}>Top 20</option>
              <option value={50}>Top 50</option>
            </select>
          </div>

<div>
            <CustomDatePicker
              label="من تاريخ"
              value={fromDate}
              onChange={setFromDate}
              placeholder="اختر تاريخ البداية"
              maxDate={toDate ? new Date(toDate) : null}
            />
          </div>

          <div>
            <CustomDatePicker
              label="إلى تاريخ"
              value={toDate}
              onChange={setToDate}
              placeholder="اختر تاريخ النهاية"
              minDate={fromDate ? new Date(fromDate) : null}
            />
          </div>

          <div>
            <label style={filterLabelStyle}>الإجراءات</label>
            <div style={{ display: "flex", gap: "8px" }}>
              <button onClick={handleFilter} style={btnPrimaryStyle}>تصفية</button>
              <button onClick={handleReset} style={btnSecondaryStyle}>إعادة ضبط</button>
            </div>
          </div>
        </div>
      </div>

      {/* Date Range Info */}
      {(fromDate || toDate) && (
        <div style={dateInfoStyle}>
          📅 عرض البيانات {fromDate && `من ${fromDate}`} {toDate && `إلى ${toDate}`}
        </div>
      )}

      {/* Table or Empty */}
      {profits.length > 0 ? (
        <div style={tableWrapperStyle}>
          <table style={tableStyle}>
            <thead style={{ background: "#dbeafe" }}>
              <tr>
                <th style={thStyle}>#</th>
                <th style={thStyle}>المنتج</th>
                <th style={thStyle}>الوصف</th>
                <th style={thStyle}>الفئة</th>
                <th style={thStyle}>العلامة التجارية</th>
                <th style={thStyle}>إجمالي الربح</th>
                <th style={thStyle}>هامش الربح</th>
                <th style={thStyle}>العلامة السعرية</th>
                <th style={thStyle}>الكمية المباعة</th>
                <th style={thStyle}>الإيرادات</th>
                <th style={thStyle}>التكلفة</th>
              </tr>
            </thead>
            <tbody>
              {profits.map((item, index) => (
                <tr key={item.productId} style={{ background: index % 2 === 0 ? "#f8fafc" : "#ffffff" }}>
                  <td style={tdStyle}>{index + 1}</td>
                  <td style={{ ...tdStyle, fontWeight: 700, color: "#2563eb" }}>{item.productName}</td>
                  <td style={{ ...tdStyle, fontWeight: 700, color: "#2563eb" }}>{item.description}</td>
                  <td style={tdStyle}>{item.categoryName}</td>
                  <td style={tdStyle}>{item.brandName}</td>
                  <td style={tdStyle}>{item.totalProfit.toLocaleString()} EGP</td>
                  <td style={tdStyle}>{item.profitMargin.toFixed(2)}%</td>
                  <td style={tdStyle}>{item.markup.toFixed(2)}%</td>
                  <td style={tdStyle}>{item.totalQuantitySold}</td>
                  <td style={tdStyle}>{item.totalRevenue.toLocaleString()} EGP</td>
                  <td style={tdStyle}>{item.totalCost.toLocaleString()} EGP</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={noDataStyle}>
          <div style={{ fontSize: "64px", color: "#94a3b8", marginBottom: "20px" }}>📊</div>
          <h4 style={{ color: "#475569", fontWeight: "600", marginBottom: "8px" }}>لا توجد بيانات ربح</h4>
          <p style={{ color: "#64748b", fontSize: "15px", marginBottom: 0 }}>جرب تعديل النطاق الزمني أو عدد الأعلى لعرض النتائج</p>
        </div>
      )}
    </div>
  );
}

// Styles
const filterBoxStyle = {
  background: "#fff",
  border: "1px solid #dbeafe",
  borderRadius: "8px",
  padding: "20px",
  boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
  marginBottom: "20px",
};
const filterTitleStyle = { color: "#1e40af", fontWeight: "600", fontSize: "16px", marginBottom: "16px" };
const filterGridStyle = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px" };
const filterLabelStyle = { color: "#475569", fontSize: "14px", fontWeight: "600", marginBottom: "6px", display: "block" };
const selectStyle = { width: "100%", padding: "10px 12px", border: "1px solid #bfdbfe", borderRadius: "6px", fontSize: "15px", color: "#475569", outline: "none", cursor: "pointer", background: "#fff" };
const inputStyle = { width: "100%", padding: "10px 12px", border: "1px solid #bfdbfe", borderRadius: "6px", fontSize: "15px", color: "#475569", outline: "none" };
const btnPrimaryStyle = { flex: 1, background: "#2563eb", color: "#fff", padding: "10px", borderRadius: "6px", border: "none", fontWeight: "600", fontSize: "14px", cursor: "pointer" };
const btnSecondaryStyle = { flex: 1, background: "#fff", color: "#475569", padding: "10px", borderRadius: "6px", border: "1px solid #bfdbfe", fontWeight: "600", fontSize: "14px", cursor: "pointer" };
const dateInfoStyle = { background: "#dbeafe", border: "1px solid #93c5fd", borderRadius: "6px", padding: "12px 16px", color: "#1e40af", fontSize: "14px", fontWeight: "600", marginBottom: "20px" };
const tableWrapperStyle = { overflowX: "auto", background: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)" };
const tableStyle = { width: "100%", borderCollapse: "collapse", textAlign: "center" };
const thStyle = { color: "#1e40af", fontSize: "13px", padding: "14px 10px", fontWeight: "600", border: "1px solid #bfdbfe", whiteSpace: "nowrap" };
const tdStyle = { padding: "12px 10px", border: "1px solid #e0e7ff", fontSize: "14px", fontWeight: "600", color: "#475569" };
const noDataStyle = { background: "#fff", border: "1px solid #dbeafe", borderRadius: "8px", padding: "60px 20px", textAlign: "center", boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)" };
